import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';

import { PropertiesLabel } from '@/modules/common/components/PropertiesLabel';
import { NumberInput } from '@/modules/common/components/inputs';

type Props = {
  value: number;
  onChange: (obstructionTimeOut: number) => void;
};

const MIN_VALUE = 0;

export const ObstructionTimeInSeconds = ({ value, onChange }: Props) => {
  const { t } = useTranslation('interface');

  const onChangeValue = useCallback(
    (v) => {
      if (v >= MIN_VALUE) {
        onChange(v);
      }
    },
    [onChange],
  );

  return (
    <PropertiesLabel
      labelRatio={50}
      i18nkey='interface:simulation.experimental_settings.obstructionTimeOut.label'
    >
      <NumberInput
        value={value}
        onChange={onChangeValue}
        unit={t('simulation.experimental_settings.obstructionTimeOut.unit')}
        decimals={0}
        sx={{ float: 'right', height: '32px' }}
        minValue={MIN_VALUE}
        minValueErrorMsg={t('common:minimum_value', { minValue: MIN_VALUE })}
      />
    </PropertiesLabel>
  );
};
